import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		menu: null,
		token: 'ddddtesttoken',
		name: '',
		// 1.统一认证登录过来的，2.后台登录页登录
		from:1,
		companys:null
	},
	mutations: {
		setMenu(state, data) {
			state.menu = data
		},
		setToken(state, data) {
			state.token = data
		},
		setName(state, data) {
			state.name = data
		},
		setCompany(state,data){
			state.companys = data;
		},
		setFrom(state, data) {
			state.from = data
		}
	},
	actions: {
		setMenu(context, data) {
			context.commit('setMenu', data)
		},
		setToken(context, data) {
			context.commit('setToken', data)
		},
		setName(context, data) {
			context.commit('setName', data)
		},
		setFrom(context, data) {
			context.commit('setFrom', data)
		},
		setCompany(context,data){
			context.commit('setCompany', data)
		},
	}
})

export default store
